<template>
  <div id="container">
    <div class="product-status">
      <div class="box-content-title">
        <div class="title-font-style">
          <span>团队采购计划</span>
        </div>
      </div>
      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="params.column" @change="columnChange(params.column)">
                <el-option
                  v-for="(item, index) in contractScreenCondition"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="params.column === 'isMeger'">
            <el-form-item>
              <el-select v-model="params.value">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="params.column === 'stockupType'">
            <el-form-item>
              <el-select style="width:100%;" v-model="params.value">
                <el-option label="入库备货" value="入库备货"></el-option>
                <el-option label="直发备货" value="直发备货"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="6"
            v-if="
                  params.column === 'createDate' ||
                    params.column === 'deliveryTime'
                "
          >
            <el-form-item>
              <el-date-picker
                style="width:100%;"
                v-model="time"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            :span="6"
            v-if="
                  params.column !== 'createDate' &&
                    params.column !== 'deliveryTime'&&
                    params.column !== 'isMeger'&&
                    params.column !== 'stockupType'
                "
          >
            <el-form-item>
              <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button @click="search" type="primary">搜索</el-button>
              <el-button @click="resetSearch" type>重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height: tableHeight+'px'}">
        <el-table
          border
          :max-height="tableHeight"
          ref="tableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="采购计划编号" width="160px">
            <template slot-scope="scope">
              <span class="approval" @click="onPurchasePlanDetails(scope.row)">
                {{
                scope.row.ocspCode
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop label="关联备货编号" width="150px">
            <template slot-scope="scope">
              <span class="approval" @click="onStockUpEdit(scope.row)">
                {{
                scope.row.stockupCode
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="stockupType" label="备货方式"></el-table-column>
          <el-table-column prop="storageName" label="备货仓"></el-table-column>
          <el-table-column prop="brandName" label="备货品牌"></el-table-column>
          <el-table-column prop="suName" label="询价供应商" width="100px"></el-table-column>
          <el-table-column prop="createDate" label="计划生成时间" width="150px">
            <template slot-scope="scope">
              <span @click="onStockUpEdit">
                {{
                scope.row.createDate | dateFilter
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryTime" label="预计发货时间" width="150px">
            <template slot-scope="scope">
              <span @click="onStockUpEdit">
                {{
                scope.row.deliveryTime | dateFilter
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="isMeger" label="是否合并计划" width="110px">
            <template slot-scope="scope">
              <span>{{ scope.row.isMeger === 0 ? "否" : "是" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="staffCnName" label="处理人"></el-table-column>
          <el-table-column prop="orgName" label="所属部门"></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { queryOrderStockupPurchaseTeam } from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'

import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
export default {
  components: {
    pagination: pagination
  },
  data () {
    return {
      time: [],
      activeName: '团队采购计划记录',
      expressionList: expressionList,
      queryParams: {}, // 搜索条件
      params: {},
      list: [{ code: 'jw999-000' }],
      loadingTable: false,
      contractScreenCondition: [
        { label: '采购计划编号', value: 'ocspCode' },
        { label: '备货编号', value: 'stockupCode' },
        { label: '备货方式', value: 'stockupType' },
        { label: '备货仓', value: 'storageName' },
        { label: '备货品牌', value: 'brandName' },
        { label: '询价供应商', value: 'suName' },
        { label: '计划生成时间', value: 'createDate' },
        { label: '预计发货时间', value: 'deliveryTime' },
        { label: '是否合并计划', value: 'isMeger' },
        { label: '认领人', value: 'staffCnName' },
        { label: '所属部门', value: 'orgName' }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 30,
      tableHeight: window.innerHeight - 390

    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    handleClick () { },
    columnChange (column) {
      this.time = []
      this.params = {
        column: column
      }
    },
    search () {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }
      if (this.params.value === undefined || this.params.value === '') {
        this.$message.error('请输入搜索条件')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    resetSearch () {
      this.time = []
      this.params = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryOrderStockupPurchaseTeam(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看
    onPurchasePlanDetails (row) {
      this.$router.push({
        name: 'purchasePlanDetails',
        query: { ocspCode: row.ocspCode, type: 'result' }
      })
    },
    // 备货详情编号
    onStockUpEdit (val) {
      this.$router.push({
        name: 'distributionResult',
        query: { ocsId: val.ocsId }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
